const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();
//const bodyLimitHeight = (windowHeight - 185) * 0.88;

let url = location.href;

//ローディング
const loading = () => {
  const $target = $('#idx-Loading');
  window.addEventListener('load',function(){
    setTimeout( () => {
      $target.fadeOut(600);
    }, 1000);
  });
};

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};

//ページTOP
const pageTop = () =>{
  const topBtn = $('.sw-Top');
  topBtn.css({visibility:'hidden',opacity: 0});
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.css({visibility:'visible',opacity: 1});
    } else {
      topBtn.css({visibility:'hidden',opacity: 0});
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
};

//画像切り替え
const visualChange = () => {
  const $switcher = $('.js-Visual_Switcher');
  $switcher.each(function(){
    const $this = $(this)
    $(this).children('.btn').click(function () {
      const index = $($this).children('.btn').index(this);
      const $visual = $(this).parents('.detail').siblings('.image');
      $visual.children('img').removeClass('active');
      $visual.children('img').eq(index).addClass('active');
      // $('#js-Visual_Switcher li').removeClass('active');
      // $(this).addClass('active');
    });
  });
};


//export
export {loading, anchorScroll, pageTop, visualChange};


// WEBPACK FOOTER //
// module.js